import React, {useEffect, useState } from 'react'
import { Link, useLoaderData} from 'react-router-dom'
import Portfolio from './Portfolio';

const PortfolioData = () => {

  const portfolio=useLoaderData();
  const [portfolioData,setPortfolioData] = useState([]);
  const [filterPortfolio,setFilterPortfolio]=useState(portfolio);

useEffect(()=>{
  if(window.location.pathname === '/portfolio'){
    setPortfolioData(portfolio)
  }else{
    setPortfolioData(portfolio?.slice(0,9))
  }
},[])

const handlePortfolioFilter=(event)=>{
  const filterName=event.target.name;
  if(window.location.pathname === '/portfolio'){
      if(filterName === "showall"){
          setPortfolioData(portfolio)
      }else{
          const filterValue=portfolio.filter((filterData)=>filterData.title === filterName);
          setPortfolioData(filterValue);
      }
  }else{
      if(filterName === "showall"){
        setPortfolioData(portfolio?.slice(0,9))
    }else{
      const filterValue=portfolio?.filter((filterData)=>filterData.title === filterName);
        setPortfolioData(filterValue);
    }
  }
}

// const handlePortfolioFilter=(event)=>{
//   const filterName=event.target.name;
//     if(filterName === "showall"){
//       setFilterPortfolio(portfolio)
//     }else{
//       const filterValue=portfolio.filter((filterData)=>filterData.title === filterName);
//       setFilterPortfolio(filterValue);
//     }
// }

  return (
    <div className='py-20 bg-[#0E1629]'>
      <div className='container'>
        {window.location.pathname === '/portfolio' ? "" :<div className="text-center pb-8">
              <h1 className="text-5xl font-medium text-[#22d3ee]">Portfolio</h1>
              <p className="text-base mt-1 text-white">My previous work</p>
          </div>
          }
          <div className='flex flex-wrap items-center justify-center mb-8'>
                <button onClick={handlePortfolioFilter} className="bg-transparent text-white capitalize border-2 border-[#22d3ee] py-2 px-6 rounded-full mt-3 hover:bg-[#22d3ee] hover:text-white duration-500 mr-3 " name='showall'>Show All</button>
                <button onClick={handlePortfolioFilter} className="bg-transparent text-white capitalize border-2 border-[#22d3ee] py-2 px-6 rounded-full mt-3 hover:bg-[#22d3ee] hover:text-white duration-500 mr-3 " name='Resturent'>Resturent</button>
                <button onClick={handlePortfolioFilter} className="bg-transparent text-white capitalize border-2 border-[#22d3ee] py-2 px-6 rounded-full mt-3 hover:bg-[#22d3ee] hover:text-white duration-500 mr-3 " name='Business'>Business</button>
                <button onClick={handlePortfolioFilter} className="bg-transparent text-white capitalize border-2 border-[#22d3ee] py-2 px-6 rounded-full mt-3 hover:bg-[#22d3ee] hover:text-white duration-500 mr-3 " name='Travel'>Travel</button>
                <button onClick={handlePortfolioFilter} className="bg-transparent text-white capitalize border-2 border-[#22d3ee] py-2 px-6 rounded-full mt-3 hover:bg-[#22d3ee] hover:text-white duration-500 mr-3 " name='Portfolio'>Portfolio</button>
                <button onClick={handlePortfolioFilter} className="bg-transparent text-white capitalize border-2 border-[#22d3ee] py-2 px-6 rounded-full mt-3 hover:bg-[#22d3ee] hover:text-white duration-500 mr-3 " name='Dental'>Dental</button>
                <button onClick={handlePortfolioFilter} className="bg-transparent text-white capitalize border-2 border-[#22d3ee] py-2 px-6 rounded-full mt-3 hover:bg-[#22d3ee] hover:text-white duration-500 mr-3 " name='E-commerce'>E-commerce</button>
                <button onClick={handlePortfolioFilter} className="bg-transparent text-white capitalize border-2 border-[#22d3ee] py-2 px-6 rounded-full mt-3 hover:bg-[#22d3ee] hover:text-white duration-500 mr-3 " name='Landing page'>Landing page</button>
          </div>
          <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-5'>
             {portfolioData && portfolioData.map((portfolio)=><Portfolio key={portfolio.id} portfolio={portfolio}></Portfolio>)}
          </div>
          {window.location.pathname === '/portfolio' ? "" :<div className='text-center'>
              <Link to={'/portfolio'} className="text-white capitalize btn bg-[#22d3ee] hover:border-2 hover:border-[#22d3ee] px-10 rounded-md mt-10 hover:bg-transparent hover:text-white duration-500">See All</Link>
          </div>
          }
      </div>
    </div>
  )
}

export default PortfolioData;